module.exports = __webpack_public_path__ + "img/email_icon.0802accc.svg";